import React from 'react';
import PageCTA from './PageCTA';
import styles from './dressCodePageCta.module.scss';
import { PagesFragment, Wws_Page, Wws_AllowedCreatePageType } from '../../../generated/graphql';

interface Props {
  onCreatedPage?: (page: PagesFragment | Wws_Page) => void;
}

// Specialized Dress Code page creation CTA with baked in defaults
export const DressCodePage: React.FC<Props> = ({ onCreatedPage }) => {
  const pageAttributes = {
    title: 'Dress Code',
    description: 'Guidance on attire for guests',
    show: true,
    rank: 5,
    type: Wws_AllowedCreatePageType.DressCodePage,
  } as const;

  return (
    <PageCTA
      subheadText="Give Guests attire guidelines"
      buttonText="Add Dress Code"
      pageAttributes={pageAttributes}
      onCreatedPage={onCreatedPage}
      dataTestIdPrefix="create-page-cta"
      wrapperClassName={styles.dressCodeCtaWrapper}
      subheadClassName={styles.dressCodeSubhead}
      buttonClassName={styles.dressCodeButton}
    />
  );
};

export default DressCodePage;
